import {
  MembershipAffiliationDto,
  MembershipAffiliationDtoAllowedLoginMethodsEnum,
  SubscriptionFlowFieldDtoTypeEnum,
} from "@shared/apis/sidekick/generated";
import { INDIVIDUAL_PLAN_ID } from "@shared/utils/constants";

export { INDIVIDUAL_PLAN_ID };

export const INDIVIDUAL_PLAN: MembershipAffiliationDto = {
  id: INDIVIDUAL_PLAN_ID,
  name: "Individual",
  abbreviation: "Individual",
  allowedLoginMethods: [
    MembershipAffiliationDtoAllowedLoginMethodsEnum.Email,
    MembershipAffiliationDtoAllowedLoginMethodsEnum.Sso,
  ],
  acceptingNewSubscribers: true,
  subscriptionFlowConfig: {
    stepStartChallenge: null,
    stepUserInfo: [
      {
        name: "name",
        type: SubscriptionFlowFieldDtoTypeEnum.Text,
        label: "Full Name",
      },
      {
        name: "email",
        type: SubscriptionFlowFieldDtoTypeEnum.Email,
        label: "E-mail",
        readOnly: true,
      },
      {
        name: "phoneNumber",
        type: SubscriptionFlowFieldDtoTypeEnum.PhoneNumber,
        label: "Phone Number",
      },
    ],
  },
};
